/**
 * Enum representing different error codes.
 */
export enum ErrorsEnum {  
  /** Error code for a not found resource. */
  Not_FOUND = 404,
}
